module.exports = {
    "Empty": `Pusty`
};


//# sourceMappingURL=pl-PL.main.js.map
